export default import.meta.ROLLDOWN_FILE_URL_kgmcYRivaHzNpECSxzT_pQ